// Font files required by FusionFontStyles
import '@fontsource/ibm-plex-mono/200.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ubuntu/400.css'
import '@fontsource/ubuntu/700.css'
import '@fontsource/source-sans-pro/400.css'
import '@fontsource/source-sans-pro/600.css'
import { Capacitor } from '@capacitor/core'
import { fusionScreenTheme, fusionPrintThemeOverrides } from '@fusion-advantage/formrender'
import { CSSObject } from '@emotion/react'

const { colors } = fusionScreenTheme

const globalBody = (background: CSSObject["background"]): CSSObject => ({
	margin: 0,
	...fusionScreenTheme.baseStyles.formRoot,
	background,
	transition: 'background 0.5 ease-in-out',
	'@media print': {
		background: colors.white,
		// 20260424 for dan's updated print process do not change zoom
		// zoom: '62%',
	},
})

export const globalStyle: CSSObject = {
	'html': {
		margin: 0,
		background: colors.transparent,
	},
	// explicitly setting transparent background
	// so camera view of @capacitor-mlkit/barcode-scanning
	// is visible below the webview
	'body': globalBody(colors.transparent),
	'#reactroot': {
		display: 'contents',
	},
}

export const globalStorybookStyle: CSSObject = {
	...globalStyle,
	'body': globalBody(colors.white),
}

// for legible fonts when printing on headless Chrome in Linux container
export const globalLinuxPrintStyle: CSSObject = {
	'body': {
		...fusionPrintThemeOverrides.baseStyles.formRoot,
	},
}

export const statusBarHeightPx = (): number => Capacitor.isNativePlatform() ? 24 : 0
